(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@wallaby-ui/document", [], factory);
	else if(typeof exports === 'object')
		exports["@wallaby-ui/document"] = factory();
	else
		root["@wallaby-ui/document"] = factory();
})(self, () => {
return 